import ToolbarTitle from "design/components/texts/ToolbarTitle";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import useLink from "qpr-base/hooks/useLink";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as PlusSign } from "../../MyDashboards/assets/PlusSign.svg";
import useDashboardEditor from "../../MyDashboards/state/editor";
import ActionButton from "../../design/components/buttons/ToolbarBtn";

const useIconStyles = makeThemedStyles("MyDashboardsToolbarIcon", (theme) => ({
  root: {
    marginLeft: 0,
    marginRight: "15px",
    marginTop: 0,
    width: "40px",
    height: "40px",
    backgroundImage: `url(${getFileApiURL(
      `/icons/navitems/icon_my_dashboards.svg`
    )})`,
  },
}));

const useStyles = makeThemedStyles("MyDashboardsToolbar", (theme) => ({
  rightSide: {
    display: "flex",
    alignItems: "center",
    marginTop: "-4px",
    marginRight: "30px",
    gap: "10px",
  },
  button: {},
  plusSign: {},
}));

const MyDashboardsToolbar = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const iconstyles = useIconStyles();
  const link = useLink({ noPeriod: true });
  const clearEditor = useDashboardEditor((s) => s.clearEditor);
  return (
    <ToolbarContainer>
      <SplitView partCnt={2}>
        <ToolbarTitle>
          <span className={iconstyles.root}></span>
          {t("myStories.My Dashboards")}
        </ToolbarTitle>
        <Right>
          <div className={classes.rightSide}>
            <ActionButton
              startIcon={<PlusSign className={classes.plusSign} />}
              text={t("myStories.Create Dashboard")}
              onClick={() => {
                clearEditor();
                link({ page: "createdashboard" });
              }}
              color="grayBg"
            />
          </div>
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default MyDashboardsToolbar;
